import React from 'react'
import {
  PromoLogoContainer,
  PromoSplashImage,
  PromoScreenContainer,
  Overlay,
  PromoScreenBottomContainer
} from './style'
import {
  ALT_SPLASH_LOGO,
  PROMO_SCREEN_TEXT,
  BUTTON_LABELS,
  SUPER_APP_CONFIG,
} from 'shared-ui/utils/constants'
import { GA_EVENTS, CMS_EVENTS } from 'shared-ui/utils/gaConstants'
import { universe } from 'shared-ui/assets'
import { Text, Button, SuperAppFooter } from 'shared-ui/components'
import { useTheme } from 'styled-components'
import { media } from 'shared-ui/utils/media'
import { useResponsive, useUserAnalyticsEvent } from 'shared-ui/hooks'
import { useTrackEvent } from 'shared-ui/utils/analyticEvents'
import { useLanguage } from 'shared-ui/utils/languageProvider'

const PromoContainer = ({
  createAccountClick,
  signInclick,
  guestUserClick
}) => {
  const theme = useTheme()
  const isMobile = useResponsive(media.mobile)
  const trackEvent = useTrackEvent()

  // Subscribe to language changes so promo texts re-render when language changes
  const { language } = useLanguage()

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
        <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'center', overflow: 'auto' }}>
          <PromoScreenContainer isMobile={isMobile}>
            <PromoSplashImage src={universe} alt={ALT_SPLASH_LOGO} />
            {isMobile && <Overlay />}
            <PromoLogoContainer>
              <Text gradientText fontSize={'20px'} fontWeight={600} maxLines={2} style={{ marginTop: '24px' }}>
                {PROMO_SCREEN_TEXT.HEADING}
              </Text>

              <Text fontSize={'16px'} fontWeight={400} width={'100%'} maxLines={2}>
                {PROMO_SCREEN_TEXT.SUB_HEADING} <br />{' '}
                {PROMO_SCREEN_TEXT.SUB_HEADING2}
              </Text>

              <Button
                width="100%"
                height="48px"
                borderRadius="24px"
                padding='0'
                fontSize="14px"
                fontWeight={600}
                style={{ alignSelf: 'center' }}
                onClick={() => {
                  createAccountClick()
                  trackEvent(GA_EVENTS.signup_started, {
                    entry_point: 'promo'
                  })
                }}
              >
                {BUTTON_LABELS.createNewAccount}
              </Button>

              <div style={{ fontSize: '14px' }}>
                <Text fontSize={'14px'} fontWeight={600} marginTop={'20px'}>
                  {PROMO_SCREEN_TEXT.ITEMS_LIST_TITLE}
                </Text>
                <ul style={{ listStyle: 'none', padding: 0 }} className="mt-2">
                  {PROMO_SCREEN_TEXT?.ITEMS?.map((item, index) => (
                    <li key={index} style={{ color: theme.colors.Ash }}>
                      <span className="mr-2">✔</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </PromoLogoContainer>
            <PromoScreenBottomContainer>
              <Button
                variant="outline"
                width="100%"
                height="40px"
                borderRadius="20px"
                background="transparent"
                padding="0"
                color={theme.colors.Blue}
                border={`1px solid ${theme.colors.Blue}`}
                style={{ marginBottom: '10px', textAlign: 'center' }}
                fontSize="14px"
                onClick={() => {
                  signInclick()
                }}
              >
                {SUPER_APP_CONFIG.PROFILE_GUEST_USER_EXISTING_USER_SIGN_IN}
              </Button>
              <div
                onClick={() => {
                  guestUserClick()
                  trackEvent(GA_EVENTS.guest_mode_entered, {
                    entry_point: 'promo'
                  })
                }}
                style={{ color: theme.colors.Blue, cursor: 'pointer' }}
              >
                {BUTTON_LABELS.exploreGuest}
              </div>
            </PromoScreenBottomContainer>
          </PromoScreenContainer>
        </div>
        <div className="z-10 w-full">
          <SuperAppFooter padding="20px 50px" />
        </div>
      </div>
    </>
  )
}

export default PromoContainer
